import $api from "../http"

class Service {
    static async getListBonuses(user_id) {
        return $api.post("", {
            type: "getListBonuses",
            user_id
        }, {headers: {"Content-Type": "multipart/form-data; boundary=something"}})
    }
    static async cancelBonus(user_id) {
        return $api.post("", {
            type: "cancelBonus",
            user_id
        }, {headers: {"Content-Type": "multipart/form-data; boundary=something"}})
    }


    static async getBonus(user_id, bonus_id, action) {
        return $api.post("", {
            type: "getBonus",
            user_id,
            bonus_id,
            action
        }, {headers: {"Content-Type": "multipart/form-data; boundary=something"}})
    }

    static async activate_bonus(user_id, bonus_id, action) {
        return $api.post("", {
            type: "activateBonus",
            user_id,
            bonus_id,
            action
        }, {headers: {"Content-Type": "multipart/form-data; boundary=something"}})

    }

}

export default Service